export const REFERRAL_LOADING = "REFERRAL_LOADING";
export const GET_INVITE_LINKS = "GET_INVITE_LINKS";
export const GET_REFERRAL_LOGIN = "GET_REFERRAL_LOGIN";
export const REMOVE_REFERRAL_DATA = "REMOVE_REFERRAL_DATA";
